// extracted by mini-css-extract-plugin
export default {"rdc_icon":"Icon_rdc_icon__xoDrd"};